// Tempo relativo em pt-BR ("há 5 min", "há 9 dias"). Futuro, zero ou inválido = "agora".
export function tempoRelativo(ts, agora = Date.now()) {
  const t = Number(ts);
  if (!Number.isFinite(t) || t <= 0) return 'agora';
  const seg = Math.floor((agora - t) / 1000);
  if (!(seg > 0)) return 'agora';
  if (seg < 60) return `há ${seg}s`;
  const min = Math.floor(seg / 60);
  if (min < 60) return `há ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `há ${h} h`;
  const d = Math.floor(h / 24);
  return `há ${d} ${d === 1 ? 'dia' : 'dias'}`;
}
